import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import Logo from "@/components/Logo";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim()) { toast.error("Please enter your email"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 w-full max-w-[400px]">
        <div className="flex justify-center mb-6">
          <Logo size="large" theme="light" />
        </div>

        {sent ? (
          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg width="32" height="32" fill="none" stroke="#22c55e" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-[#1e293b] mb-2">Check your email</h1>
            <p className="text-[#64748b] text-sm mb-6">
              If <strong>{email}</strong> has an account, we've sent a password reset link. Check your inbox.
            </p>
            <p className="text-sm text-[#94a3b8] mb-4">Didn't get it? Check your spam folder.</p>
            <button onClick={() => setSent(false)} className="text-[#6366f1] text-sm hover:underline font-medium">
              Try a different email
            </button>
          </div>
        ) : (
          <>
            <h1 className="text-xl font-bold text-[#1e293b] text-center mb-1">Forgot your password?</h1>
            <p className="text-[#64748b] text-sm text-center mb-6">Enter your email and we'll send you a reset link.</p>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-[#1e293b] block mb-1">Email address</label>
                <input
                  type="email" value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleSubmit()}
                  className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#6366f1]"
                  placeholder="you@example.com"
                  autoFocus data-testid="forgot-email-input"
                />
              </div>
              <button onClick={handleSubmit} disabled={loading}
                className="w-full text-white font-bold py-2.5 rounded-lg text-sm disabled:opacity-50 transition-colors"
                style={{ background: loading ? "#a5b4fc" : "#6366f1" }}
                data-testid="forgot-submit-btn">
                {loading ? "Sending..." : "Send Reset Link \u2192"}
              </button>
            </div>
          </>
        )}

        <div className="mt-6 pt-5 border-t border-slate-100 text-center">
          <Link to="/login" className="text-sm text-[#64748b] hover:text-[#1e293b]">
            &larr; Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
